.icon {
  display: flex;
  gap: 0.2rem;
  align-items: end;

  & span {
    width: 0.3rem;
    height: 0.6rem;
    border-radius: 0.1rem;
    background-color: #31343c;

    &:nth-child(1) {
      &[data-priority='1'],
      &[data-priority='2'],
      &[data-priority='3'] {
        background-color: #7a8296;
      }
    }

    &:nth-child(2) {
      height: 0.9rem;

      &[data-priority='2'],
      &[data-priority='3'] {
        background-color: #7a8296;
      }
    }

    &:nth-child(3) {
      height: 1.2rem;

      &[data-priority='3'] {
        background-color: #7a8296;
      }
    }
  }
}
